import Constants from "expo-constants"

export const s3PostCodeDomain =
  Constants.expoConfig?.extra?.env == "prd"
    ? "https://ra9ra9-postcode-prod.s3.ap-northeast-1.amazonaws.com/"
    : Constants.expoConfig?.extra?.env == "stg"
    ? "https://ra9ra9-postcode-stg.s3.ap-northeast-1.amazonaws.com/"
    : "https://ra9ra9-postcode-dev.s3.ap-northeast-1.amazonaws.com/"
